<ng-container *transloco="let t">
  <pxc-choice-picker [title]="t('Avec qui souhaitez-vous démarrer un télésuivi ?')">
    <pxc-card-button
      data-testid="by-patient"
      icon="@tui.user"
      [description]="
        t('Le patient recevra par SMS un lien pour ajouter lui-même ses photos et remplir un questionnaire.')
      "
      [title]="t('Avec un patient')"
      (click)="byPatient()" />
    <pxc-card-button
      data-testid="by-user"
      icon="@tui.heart-handshake"
      [description]="
        t(
          'L’infirmier utilisera l’application Pixacare afin d’ajouter des photos du patient et remplir un questionnaire.'
        )
      "
      [title]="t('Avec un infirmier')"
      (click)="byUser()" />
  </pxc-choice-picker>
</ng-container>
